import type { ComponentProps, ReactNode } from 'react';

import { Collapsible, CollapsibleContent } from 'design-system';

export type CollapseProps = Omit<ComponentProps<'div'>, 'children'> & {
  children?: ReactNode;
  in: boolean;
  unmountOnExit?: boolean;
};

/** Compatibility bridge for the former `Collapse` API while callers are migrated. */
export const Collapse = ({ children, in: open, unmountOnExit = true, ...props }: CollapseProps) => (
  <Collapsible open={open}>
    {open || !unmountOnExit ? <CollapsibleContent {...props}>{children}</CollapsibleContent> : null}
  </Collapsible>
);
